// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ForecastsCreateSchema = z.object({
  forecast: z.object({
    title: z.coerce.string().describe("Task title"),
    description: z.coerce.string().describe("Detailed description").nullish(),
    from: z.coerce.string().describe("Start date (YYYY-MM-DD)"),
    to: z.coerce.string().describe("End date (YYYY-MM-DD)"),
    project_id: z.number().int().describe("Project ID"),
    user_id: z.optional(z.number().int().describe("Primary user ID (alternative to users array)")),
    users: z.optional(z.array(z.object({})).describe("User assignments with per-user estimates")),
    estimated_minutes: z.optional(z.number().int().describe("Estimated time in minutes")),
    label_ids: z.optional(z.array(z.number().int()).describe("Tag/label IDs to apply")),
    completed_at: z.coerce.string().describe("ISO 8601 timestamp to mark as completed").nullish(),
    external_id: z.coerce.string().describe("External system identifier for integration mapping").nullish(),
  }),
});
